// Uma notificação na lista (sino e página de notificações).
import { Info, OctagonAlert, TriangleAlert } from 'lucide-react'
import type { NotificationDto } from '@impulso/shared/api/notifications'
import { timeAgo } from './api'

const ICON = {
  info: { Icon: Info, cls: 'blue', label: 'Aviso' },
  warning: { Icon: TriangleAlert, cls: 'amber', label: 'Atenção' },
  critical: { Icon: OctagonAlert, cls: 'red', label: 'Urgente' },
} as const

export function NotificationItem({ n, onOpen, compact }: { n: NotificationDto; onOpen: (n: NotificationDto) => void; compact?: boolean }) {
  const s = ICON[n.severity] ?? ICON.info
  return (
    <button
      type="button"
      className="list-item"
      onClick={() => onOpen(n)}
      style={{
        width: '100%', textAlign: 'left', background: n.read ? 'transparent' : 'var(--primary-50)', border: 'none',
        borderBottom: '1px solid var(--border)', borderRadius: 0, padding: compact ? '10px 12px' : '14px 16px', cursor: 'pointer', color: 'inherit',
      }}
    >
      <span className={`ic ${s.cls}`} aria-label={s.label}><s.Icon size={17} /></span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span className="row between" style={{ alignItems: 'flex-start' }}>
          <span className="strong" style={{ fontWeight: n.read ? 550 : 700 }}>{n.title}</span>
          <span className="small muted nowrap">{timeAgo(n.createdAt)}</span>
        </span>
        <span className="small" style={{ display: 'block', color: 'var(--text-2)', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', ...(compact ? { display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' as const } : {}) }}>
          {n.body}
        </span>
        {n.companyName && <span className="small muted" style={{ display: 'block', marginTop: 4 }}>{n.companyName}</span>}
      </span>
      {!n.read && <span className="status-dot" aria-label="Não lida" style={{ background: 'var(--primary)', marginTop: 6 }} />}
    </button>
  )
}
